'use client';

import { Badge } from '@/components/ui/badge';
import { Bot, Shield, FileText, Download, Users, Star } from 'lucide-react';

export function FeaturesSection() {
    return (
        <>
            {/* Social Proof / Reviews Section */}
            <section className="py-20 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-16">
                        <Badge className="mb-6 bg-yellow-100 text-yellow-700 hover:bg-yellow-200 border-0">
                            <Star className="w-4 h-4 mr-2" />
                            Reviews
                        </Badge>
                        <h2 className="text-4xl font-bold text-gray-900 mb-6">
                            Used by Students & Writers Around the World
                        </h2>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                            Humanit helped writers discretely 🤫 write over <span className="font-semibold text-purple-600">1 billion words</span>. From essays and research papers to assignments—all recognized as human-crafted by AI detection tools.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-3 gap-8">
                        {/* Review 1 */}
                        <div className="bg-gray-50 rounded-2xl p-8">
                            <div className="flex items-center gap-1 mb-4">
                                {[...Array(5)].map((_, i) => (
                                    <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                                ))}
                            </div>
                            <blockquote className="text-gray-700 mb-6">
                                "My school uses Turnitin and one of my professors actively confronts students about AI. I was on 2 warnings and was cooked until I found this. Thanks"
                            </blockquote>
                            <div className="flex items-center gap-3">
                                <img
                                    src="/profile1.jpg"
                                    alt="Anonymous user"
                                    className="w-10 h-10 rounded-full blur-[3px] opacity-60 object-cover"
                                />
                                <div>
                                    <div className="font-semibold text-gray-900">Anonymous College Student</div>
                                </div>
                            </div>
                        </div>

                        {/* Review 2 */}
                        <div className="bg-gray-50 rounded-2xl p-8">
                            <div className="flex items-center gap-1 mb-4">
                                {[...Array(5)].map((_, i) => (
                                    <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                                ))}
                            </div>
                            <blockquote className="text-gray-700 mb-6">
                                "Saves me so much time from prompting 'sound more human, use less complicated words' then checking on GPTZero over and over. Just paste and done."
                            </blockquote>
                            <div className="flex items-center gap-3">
                                <img
                                    src="/profile2.jpg"
                                    alt="Anonymous user"
                                    className="w-10 h-10 rounded-full blur-[3px] opacity-60 object-cover"
                                />
                                <div>
                                    <div className="font-semibold text-gray-900">Anonymous Grad Student</div>
                                </div>
                            </div>
                        </div>

                        {/* Review 3 */}
                        <div className="bg-gray-50 rounded-2xl p-8">
                            <div className="flex items-center gap-1 mb-4">
                                {[...Array(5)].map((_, i) => (
                                    <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                                ))}
                            </div>
                            <blockquote className="text-gray-700 mb-6">
                                "Clients started questioning if I was using AI because everyone's paranoid now. This tool keeps me employable. Game changer honestly."
                            </blockquote>
                            <div className="flex items-center gap-3">
                                <img
                                    src="/profile3.jpg"
                                    alt="Anonymous user"
                                    className="w-10 h-10 rounded-full blur-[3px] opacity-60 object-cover"
                                />
                                <div>
                                    <div className="font-semibold text-gray-900">Anonymous Content Writer</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}